import { render, staticRenderFns } from "./SpTwoModule6.vue?vue&type=template&id=466d8ed8&scoped=true"
import script from "./SpTwoModule6.vue?vue&type=script&lang=js"
export * from "./SpTwoModule6.vue?vue&type=script&lang=js"
import style0 from "./SpTwoModule6.vue?vue&type=style&index=0&id=466d8ed8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d8ed8",
  null
  
)

export default component.exports